import api from "./api";

export const colaboradorService = {
  getAll: async () => {
    const response = await api.get("/colaboradores");
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/colaboradores/${id}`);
    return response.data;
  },

  create: async (colaboradorData) => {
    const response = await api.post("/colaboradores", colaboradorData);
    return response.data;
  },

  update: async (colaboradorData) => {
    const response = await api.put(
      `/colaboradores/${colaboradorData.id}`,
      colaboradorData,
    );
    return response.data;
  },

  delete: async (id, usuario_id) => {
    const response = await api.delete(`/colaboradores/${id}`, {
      data: { usuario_id },
    });
    return response.data;
  },

  checkUsername: async (username) => {
    const response = await api.post("/auth/check-username", { username });
    return response.data;
  },

  sendWelcomeEmail: async (data) => {
    const response = await api.post("/colaboradores/welcome-email", data);
    return response.data;
  },

  uploadPhoto: async (file) => {
    const formData = new FormData();
    formData.append("foto", file);

    const response = await api.post("/colaboradores/upload-photo", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },
};
